<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.harvestForm"
    @close="hidePopup"
    @open="openPopup"
  >
    <div class="remain">
      当前剩余 {{ initFormData.plantNum }} {{ initFormData.cropUnit }}
    </div>
    <van-form ref="harvestForm" label-width="60px" class="harvest-form" @submit="submitForm">
      <wh-field-time-popup
        v-model="form.pickTime"
        name="pickTime"
        :label="getFormLabel('pickTime')"
        :rules="rules.pickTime"
      />
      <wh-popup-dynamic-select
        label="操作人"
        :value="form.pickUserName"
        :extra-params="extraParamsItems.pickUser"
        search-name="name"
        :show-picker.sync="picker.pickUser.show"
        history-key="pickUserName"
        data-src="/api/getStaffList"
        :rules="rules.pickUserId"
      >
        <template #list="{list}">
          <div class="pick-user-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="username"
              :title="index"
              @click="pickUserOptionClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
      </wh-popup-dynamic-select>
      <wh-popup-select
        v-model="form.goodLevel"
        :show-picker.sync="picker.goodLevel.show"
        name="goodLevel"
        label="产品等级"
        :rules="rules.goodLevel"
        :columns="goodsLevel"
      />
      <van-field
        v-model.number="form.pickNum"
        name="pickNum"
        :label="getFormLabel('pickNum')"
        type="decimal"
        :rules="rules.pickNum"
      >
        <template #right-icon>
          {{ pickUnit }}
        </template>
      </van-field>
      <wh-popup-select
        v-model="form.pickType"
        :show-picker.sync="picker.pickType.show"
        name="pickType"
        label="采收类型"
        placeholder="请选择采收类型"
        :rules="rules.pickType"
        :columns="pickType"
      />
      <van-field
        v-model.trim="form.comment"
        name="comment"
        label="备注"
        type="textarea"
      />
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { PLANT_TYPE_DATE, GOODS_LEVEL, PICK_TYPE } from '@/constant/common'
import { formatTime } from '@/utils/convert/convertTime'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import WhPopupDynamicSelect from '@/components/public/WhPopupSelect/WhPopupDynamicSelect'
import api from '@/api'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'

export default {
  name: 'PickPopup',
  components: { WhFieldTimePopup, WhPopupDynamicSelect, WhPopupSelect, WhPopup },
  mixins: [formPopup],
  props: {
    cropBreedItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    const validatePickNumNotZero = (value) => {
      return value > 0
    }
    // const validatePickNum = (value) => {
    //   return this.initFormData.plantNum > value
    // }
    return {
      plantTypeData: PLANT_TYPE_DATE,
      goodsLevel: GOODS_LEVEL,
      pickType: PICK_TYPE,
      form: {
        cropBreed: undefined,
        pickTime: undefined,
        goodLevel: undefined,
        pickNum: undefined,
        unit: undefined,
        breedType: undefined,
        pickType: undefined,
        comment: undefined,
        companyId: undefined,
        landId: undefined,
        pickUserId: undefined,
        pickUserName: undefined,
        cropId: undefined,
        cropAgriGoodsId: undefined,
        traceStatus: undefined
      },
      rules: {
        pickTime: [
          {
            required: true, message: '请选择采收时间'
          }
        ],
        goodLevel: [
          {
            required: true, message: '请选择产品等级'
          }
        ],
        pickNum: [
          {
            required: true, message: '请填写采收量'
          },
          { validator: validatePickNumNotZero, trigger: 'change', message: '采收量不能小于或等于零' }
          // { validator: validatePickNum, trigger: 'change', message: '超过最大可采收量' }
        ],
        pickType: [
          {
            required: true, message: '请选择采收类型'
          }
        ],
        pickUserId: [
          {
            required: true, message: '请选择负责人'
          }
        ]
      },
      formDataShow: {
        pickTime: ''
      },
      picker: {
        pickTime: {
          show: false
        },
        pickUser: {
          show: false
        },
        goodLevel: {
          show: false
        },
        pickType: {
          show: false
        }
      },
      extraParamsItems: {
        pickUser: {
          fuzzy: 1,
          name: undefined
        }
      }
    }
  },
  computed: {
    title() {
      if (this.initFormData.cropType) {
        return `${this.plantTypeData[this.initFormData.cropType].pickType}（${this.initFormData.cropBreed}）`
      } else {
        return '采收'
      }
    },
    pickUnit() {
      return ['agri', 'fishery'].includes(this.initFormData.cropType) ? 'kg' : this.initFormData.cropUnit
    }
  },
  methods: {
    formatTime,
    getFormLabel(type) {
      const suffixMap = {
        pickNum: '数量',
        pickTime: '时间'
      }
      if (this.initFormData.cropType && this.initFormData.cropType in this.plantTypeData) {
        return `${this.plantTypeData[this.initFormData.cropType].pickType}${suffixMap[type]}`
      }
      return ''
    },
    /**
     * 对面积进行转换
     * @param newUnit {String} 新单位
     * @param value {Number} 要转换的值
     * @param oldUnit {String} 旧单位
     */
    areaConversion(newUnit, value, oldUnit = '平方米') {
      const units = this.landAreaUnits.map(item => item.name)
      if (units.includes(oldUnit) && units.includes(newUnit)) {
        let areaSquare = 0
        // 先统一转换为平方米
        switch (oldUnit) {
          case '平方米':
            areaSquare = value
            break
          case '亩':
            areaSquare = value / 0.0015
        }
        // 转换为相应单位值
        switch (newUnit) {
          case '平方米':
            break
          case '亩':
            areaSquare = areaSquare * 0.0015
        }
        return areaSquare
      } else {
        throw new Error(`不支持此单位类型转换（${oldUnit} > ${newUnit}）`)
      }
    },
    openPopup() {
      // console.log('this.initFormData = ', this.initFormData)
      if (this.formType === 'create') {
        this.formDataInit(this.form, {
          ...this.initFormData,
          cropId: this.initFormData.id,
          unit: this.pickUnit,
          breedType: this.initFormData.cropType
        })
        for (const key in this.formDataShow) {
          this.formDataShow[key] = ''
        }
      }
    },
    submitForm(form) {
      api.createControlPick(this.form).then(({ msg }) => {
        this.$toast.success(msg)
        this.hidePopup()
        this.submitFormSuccess()
      })
    },
    pickUserOptionClick(item) {
      this.picker.pickUser.show = false // 隐藏选择弹窗
      this.form.pickUserId = item.id
      this.form.pickUserName = item.name
    },
    dateSelected(type, val) {
      this.picker[type].show = false
      this.formDataShow[type] = this.formatTime(val)
      this.form.pickTime = this.formatTime(val)
    }
  }
}
</script>

<style lang='less' scoped>
.remain {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: @primary-color;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
  margin-top: 10px;
}
.pick-user-list {
  .username {
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
}
</style>
